import { combineReducers } from 'redux'
import txDebugLogsReducer from "./reducers/txDebugLogsReducer";
import testcacheReducer from "./reducers/testcacheReducer";
import addEditTestcacheReducer from "./reducers/AddEditTestcacheReducer";
import KYBTestCacheReducer from "./reducers/KYBTestCacheReducer";
import addEditKYBTestCacheReducer from "./reducers/AddEditKYBTestCacheReducer";

const supportRootReducers = combineReducers({
    txDebugLogs : txDebugLogsReducer,
    testcache: testcacheReducer,
    addEditTestcache: addEditTestcacheReducer,
    kybTestcache: KYBTestCacheReducer,
    addEditKYBTestcache: addEditKYBTestCacheReducer,
})

export default supportRootReducers;
